/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { impersonate } from '../fn/authentication/impersonate';
import { Impersonate$Params } from '../fn/authentication/impersonate';
import { loginFlow } from '../fn/authentication/login-flow';
import { LoginFlow$Params } from '../fn/authentication/login-flow';
import { logout } from '../fn/authentication/logout';
import { Logout$Params } from '../fn/authentication/logout';

@Injectable({ providedIn: 'root' })
export class AuthenticationApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `loginFlow()` */
  static readonly LoginFlowPath = '/v0/auth/login-flow';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `loginFlow()` instead.
   *
   * This method doesn't expect any request body.
   */
  loginFlow$Response(params?: LoginFlow$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return loginFlow(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `loginFlow$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  loginFlow(params?: LoginFlow$Params, context?: HttpContext): Observable<void> {
    return this.loginFlow$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `logout()` */
  static readonly LogoutPath = '/v0/auth/logout';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `logout()` instead.
   *
   * This method doesn't expect any request body.
   */
  logout$Response(params?: Logout$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return logout(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `logout$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  logout(params?: Logout$Params, context?: HttpContext): Observable<void> {
    return this.logout$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `impersonate()` */
  static readonly ImpersonatePath = '/v0/auth/impersonate';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `impersonate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  impersonate$Response(params: Impersonate$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return impersonate(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `impersonate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  impersonate(params: Impersonate$Params, context?: HttpContext): Observable<void> {
    return this.impersonate$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
